import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import ScratchCard from 'react-scratchcard-v2'
import { Loader } from '../../styles/Loader'
import {
	Main,
	MaxWidth,
	ScratchText,
	RedirectButton,
	CouponCode,
	CouponWrapper,
	ScratchCardWrapper,
} from './styles'
import { endPoints, GA, PLATFORM } from '../../constants'
import { useTransition, animated } from 'react-spring'
import { updateView } from '../../redux/slices/meta'
import { APIMethods, ReqBodyWithHeaders, ViewTypes } from '../../types/state'
import { getUserWinnings } from '../../redux/slices/user'
import { setWindowGA } from '../../helpers/DTM'
import OfferBanners from '../../components/OfferBanners'
// import { setSuccessToast } from '../../helpers/successStyles'

const Scratch = () => {
	const dispatch = useDispatch()
	const metaData = useSelector((state: RootState) => state.meta)
	const userData = useSelector((state: RootState) => state.user)
	const data = useSelector((state: RootState) => state.offers)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	// const votingAvailable = metaData.votingClose

	const {
		// LENSKART_LOGO,
		// EVENT_LOGO,
		SCRATCH_CARD,
		SCRATCH_BLNT,
		SCRATCH_KBCGOLD,
		SCRATCH_LK1,
		// SCRATCH_LK2,
		OFFER_BANNER_WON_NOTHING,
		OFFER_BANNER_WON_LK,
		OFFER_BANNER_WON_KBC,
	} = data

	const [isLoaded, setIsLoaded] = useState(false)
	const [isScratched, setIsScratched] = useState(false)
	const transition = useTransition(isLoaded, {
		from: { x: 0, y: 950, opacity: 0, delay: 450 },
		enter: { x: 0, y: 0, opacity: 1, delay: 450 },
		leave: { x: 0, y: 950, opacity: 0, delay: 450 },
	})

	useEffect(() => {
		const reqObj: ReqBodyWithHeaders = {
			method: APIMethods.POST,
			url: endPoints.scratchCardApi,
			phoneNumber: `+91${userData.phone}`,
			client: metaData.deviceType,
			sessionId: userData.sessionId,
			platformName: PLATFORM,
		}
		dispatch(getUserWinnings(reqObj))
	}, [])

	useEffect(() => {
		if (userData.userWinning !== null && userData.winnerList.length) {
			setIsLoaded(true)
			sendGA()
			sendCT()
			document.body.style.overscrollBehavior = 'none'
		}
	}, [userData])

	const sendGA = () => {
		const data = {
			event: GA.eventName,
			pageName: GA.scratchCardPage,
			mobile: btoa(userData.phone.toString()),
			pageURL: window.location.href + '/scratch',
			customerID: userData.id,
			lkUserType: userData.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)
	}

	const sendCT = () => {
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': GA.scratchCardPage,
			Phone: userData.phone,
		})
	}

	const showWinner = () => {
		dispatch(updateView(ViewTypes.WINNERS))
	}

	useEffect(() => {
		if (isScratched) {
			let cardName
			if (offerCard() === SCRATCH_BLNT) {
				cardName = GA.blntScratchCard
			} else if (offerCard() === SCRATCH_KBCGOLD) {
				cardName = GA.kbcScratchCard
			} else cardName = GA.lkScratchCard

			const data = {
				event: GA.eventName,
				pageName: cardName,
				mobile: btoa(userData.phone.toString()),
				pageURL: window.location.href + '/scratch',
				customerID: userData.id,
				lkUserType: userData.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
				loginStatus: metaData.isLogin,
				platform: metaData.platform,
			}
			setWindowGA(data)
		}
	}, [isScratched])

	const offerCard = () => {
		const platformPriceWon = userData.userWinning.platformPriceWon
		const lkPriceWon = userData.userWinning.lkPriceWon

		if (platformPriceWon === false && lkPriceWon === false) {
			return SCRATCH_BLNT
		} else if (platformPriceWon === false && lkPriceWon) {
			return SCRATCH_LK1
		} else if (platformPriceWon && lkPriceWon === false) {
			return SCRATCH_KBCGOLD
		} else {
			const finalValue = userData.winnerList.find(
				(item: any) => item.phoneNumber === '+91' + userData.phone
			)
			if (finalValue?.id) {
				return SCRATCH_KBCGOLD
			} else return SCRATCH_LK1
		}
	}

	// const copyToClipboard = (e: React.ChangeEvent<HTMLButtonElement>) => {
	// 	navigator.clipboard.writeText(e.target.value)
	// 	setSuccessToast('Coupon copied successfully')
	// 	console.log('Copied!')
	// }

	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<MaxWidth>
							<Main>
								<ScratchCardWrapper>
									<ScratchCard
										width={246}
										height={300}
										image={SCRATCH_CARD}
										finishPercent={10}
										onComplete={() => {
											setIsScratched(true)
										}}
									>
										<div
											style={{
												display: 'flex',
												width: '100%',
												height: '100%',
												alignItems: 'center',
												justifyContent: 'center',
											}}
										>
											{userData.winnerList.length > 0 && (
												<img
													src={offerCard()}
													width={246}
													height={300}
													alt="OfferCard"
												/>
											)}
										</div>
									</ScratchCard>
								</ScratchCardWrapper>
								{offerCard() === SCRATCH_LK1 && isScratched && (
									<CouponWrapper>
										<CouponCode
											// onClick={(e: any) => copyToClipboard(e)}
											value={userData?.userWinning?.lkPriceText}
											id="couponCodeID"
										>
											{userData?.userWinning?.lkPriceText}
										</CouponCode>
									</CouponWrapper>
								)}
								<ScratchText>
									{isScratched ? (
										<RedirectButton onClick={showWinner}>
											{translations.SEE_ALL_WINNER}
										</RedirectButton>
									) : (
										translations.SCRATCH_CAR_TO_WIN
									)}
								</ScratchText>
							</Main>
							{offerCard() === SCRATCH_BLNT && isScratched && (
								<OfferBanners
									OFFER_BANNER={OFFER_BANNER_WON_NOTHING}
									phoneNo={userData.phone}
									scratch={true}
								/>
							)}
							{offerCard() === SCRATCH_LK1 && isScratched && (
								<OfferBanners
									OFFER_BANNER={OFFER_BANNER_WON_LK}
									phoneNo={userData.phone}
									customStyle={true}
									scratch={true}
								/>
							)}
							{offerCard() === SCRATCH_KBCGOLD && isScratched && (
								<OfferBanners
									OFFER_BANNER={OFFER_BANNER_WON_KBC}
									phoneNo={userData.phone}
									scratch={true}
								/>
							)}
						</MaxWidth>
					</animated.div>
				) : (
					<Loader />
				)
			)}
		</>
	)
}

export default Scratch
